import React from 'react';
import Icon from 'components/AppIcon';

const TRENDING = [
  { id: 1, tag: 'REITsForBeginners', posts: 234, trend: 'up' },
  { id: 2, tag: 'WomenInVC', posts: 189, trend: 'up' },
  { id: 3, tag: 'MarketVolatility2026', posts: 156, trend: 'up' },
  { id: 4, tag: 'DividendInvesting', posts: 143, trend: 'stable' },
  { id: 5, tag: 'StartupFunding', posts: 98, trend: 'up' },
  { id: 6, tag: 'CryptoWomen', posts: 87, trend: 'down' },
];

export default function TrendingTopics() {
  return (
    <div className="bg-white rounded-xl border overflow-hidden" style={{ borderColor: 'var(--color-border)' }}>
      <div className="px-4 py-3 border-b flex items-center gap-2" style={{ borderColor: 'var(--color-border)' }}>
        <Icon name="TrendingUp" size={16} color="var(--color-accent)" />
        <h3 className="font-heading font-semibold text-sm" style={{ color: 'var(--color-foreground)' }}>Trending Topics</h3>
      </div>
      <div className="divide-y" style={{ borderColor: 'var(--color-border)' }}>
        {TRENDING?.map((topic, i) => (
          <button key={topic?.id} className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-gray-50 transition-colors text-left">
            <div className="flex items-center gap-2">
              <span className="font-data text-xs w-4" style={{ color: 'var(--color-muted-foreground)' }}>{i + 1}</span>
              <div>
                <p className="font-caption text-sm font-medium" style={{ color: 'var(--color-primary)' }}>#{topic?.tag}</p>
                <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{topic?.posts} posts</p>
              </div>
            </div>
            <Icon
              name={topic?.trend === 'up' ? 'TrendingUp' : topic?.trend === 'down' ? 'TrendingDown' : 'Minus'}
              size={14}
              color={topic?.trend === 'up' ? '#059669' : topic?.trend === 'down' ? '#DC2626' : 'var(--color-muted-foreground)'}
            />
          </button>
        ))}
      </div>
    </div>
  );
}